export class TrainingPlanningAgency {
    constructor(
        public id: number,
        public name: string,
        public address: string
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/_services/technical/training-planning-agency/training-planning-agency.model.ts